import { Effect } from "../types/effects";
import { Timestamp } from "firebase/firestore";
export interface Style {
  name: string;
  image: string;
}

export const effects: Effect[] = [
  {
    id: "1",
    title: "Vintage Film",
    image:
      "https://plus.unsplash.com/premium_photo-1698578278633-689085bd451f?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NXx8VmludGFnZSUyMEZpbG18ZW58MHx8MHx8fDA%3D",
    description:
      "Gives your video a classic, old-film look with grain and warm tones.",
    recommendedImageDesc: "Works best with portraits and scenic shots.",
    prompt:
      "Create the video to emulate an old vintage film: 8mm style, warm tones, natural film grain, subtle flicker, cinematic pacing, nostalgic atmosphere.",
    fluxCost: 10,
    type: "video",
    creatorId: "dreamworld",
    useCount: 0,
    createdAt: Timestamp.now(),
  },
  {
    id: "2",
    title: "Cyberpunk Glitch",
    image:
      "https://images.unsplash.com/photo-1728739529355-31dcaefd82b7?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8OHx8Q3liZXJwdW5rJTIwR2xpdGNofGVufDB8fDB8fHww",
    description: "Adds futuristic digital glitches and neon effects.",
    recommendedImageDesc:
      "Ideal for urban night scenes and tech-focused subjects.",
    prompt:
      "Animate the video with a cyberpunk aesthetic: neon lights, glitch distortions, digital noise, flickering holograms, futuristic city vibe, dynamic energy.",
    fluxCost: 10,
    type: "video",
    creatorId: "dreamworld",
    useCount: 0,
    createdAt: Timestamp.now(),
  },
  {
    id: "3",
    title: "Dreamy Watercolor",
    image:
      "https://media.istockphoto.com/id/1045514532/fr/photo/%C3%A9toile-de-no%C3%ABl.webp?a=1&b=1&s=612x612&w=0&k=20&c=ltliYpGr06VaNwUPBiTrYtFxzViVj_a4jq_Ka7AuAPk=",
    description:
      "Transforms your video into a soft, flowing watercolor painting.",
    recommendedImageDesc: "Best for landscapes, flowers, and calm scenes.",
    prompt:
      "Render the video as if painted in watercolor: soft flowing strokes, pastel palette, gentle blending, dreamy ambiance, subtle motion in every element.",
    fluxCost: 10,
    type: "video",
    creatorId: "dreamworld",
    useCount: 0,
    createdAt: Timestamp.now(),
  },
  {
    id: "4",
    title: "Anime Action",
    image:
      "https://occ-0-8407-90.1.nflxso.net/dnm/api/v6/E8vDc_W8CLv7-yMQu8KMEC7Rrr8/AAAABTbsm4OXWRLTpIakj0jtkvV1iemhO4H-ZjDjZSDef5mtEDzNOBDgmJfaNczp6wXwrNlSMEw0yM2xKvlDpygkifFckckPDIrVdnpf.jpg?r=54d",
    description: "Applies dynamic anime-style action lines and effects.",
    recommendedImageDesc: "Great for action shots and dynamic movements.",
    prompt:
      "Animate the video in high-energy anime style: include speed lines, dynamic camera angles, exaggerated motion, vibrant colors, impact frames, cinematic anime action.",
    fluxCost: 10,
    type: "video",
    creatorId: "dreamworld",
    useCount: 0,
    createdAt: Timestamp.now(),
  },
  {
    id: "5",
    title: "Noir Thriller",
    image:
      "https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/6939cd27-727f-4d6d-985b-198013a2db63/dj5sc3j-ff2dd78d-2d9c-45fc-9d0b-b005809b9cd9.jpg?token=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7InBhdGgiOiJcL2ZcLzY5MzljZDI3LTcyN2YtNGQ2ZC05ODViLTE5ODAxM2EyZGI2M1wvZGo1c2Mzai1mZjJkZDc4ZC0yZDljLTQ1ZmMtOWQwYi1iMDA1ODA5YjljZDkuanBnIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmZpbGUuZG93bmxvYWQiXX0.VmfhlUMLc2L-sFxHnW2hrG7jRNat6lqZiEcLrH3Nsb0",
    description: "Creates a high-contrast, black and white noir look.",
    recommendedImageDesc:
      "Perfect for dramatic portraits and mysterious scenes.",
    prompt:
      "Render the video with film noir style: high-contrast black and white, deep shadows, moody lighting, cinematic tension, slow dramatic movement.",
    fluxCost: 10,
    type: "video",
    creatorId: "dreamworld",
    useCount: 0,
    createdAt: Timestamp.now(),
  },
  {
    id: "6",
    title: "Retro Arcade",
    image: "https://images.unsplash.com/photo-1511512578047-dfb367046420?w=400",
    description: "Pixelates your video and adds an 8-bit arcade game feel.",
    recommendedImageDesc: "Fun for any subject, especially people and pets.",
    prompt:
      "Convert the video to retro arcade style: pixelated 8-bit graphics, bright block colors, animated sprites, chiptune energy, playful game-like motion.",
    fluxCost: 10,
    type: "video",
    creatorId: "dreamworld",
    useCount: 0,
    createdAt: Timestamp.now(),
  },
  {
    id: "7",
    title: "Cosmic Bloom",
    image: "https://images.unsplash.com/photo-1462331940025-496dfbfc7564?w=400",
    description:
      "Makes elements in your video bloom with cosmic light and particles.",
    recommendedImageDesc: "Best with a clear subject on a dark background.",
    prompt:
      "Animate the video with a cosmic aesthetic: glowing particles, nebula-inspired light blooms, ethereal movements, magical shimmering effects.",
    fluxCost: 10,
    type: "video",
    creatorId: "dreamworld",
    useCount: 0,
    createdAt: Timestamp.now(),
  },
  {
    id: "8",
    title: "Ink Sketch",
    image:
      "https://i.ytimg.com/vi/pyaZp7uaCwg/hq720.jpg?sqp=-oaymwEhCK4FEIIDSFryq4qpAxMIARUAAAAAGAElAADIQj0AgKJD&rs=AOn4CLCDVrvQmHBkfS7C022nXh5BOS5Org",
    description: "Redraws your video as a black and white ink sketch.",
    recommendedImageDesc: "Works well with architecture and still life.",
    prompt:
      "Transform the video into a hand-drawn ink sketch: black and white lines, hatching, detailed pen strokes, animated sketch-style movement, subtle flow.",
    fluxCost: 10,
    type: "video",
    creatorId: "dreamworld",
    useCount: 0,
    createdAt: Timestamp.now(),
  },
  {
    id: "9",
    title: "Fire and Embers",
    image:
      "https://streamline.imgix.net/972629d1-4eda-430f-8886-0d86f91bc9b4/74bd838b-879f-422a-98b3-ffbe14db9655/fire-flames.jpg?ixlib=rb-1.1.0&w=2000&h=2000&fit=max&or=0&s=89f7a9daa34d15f285a66663b17b07e0",
    description:
      "Adds realistic fire effects and glowing embers to your video.",
    recommendedImageDesc: "Dramatic effect for portraits or objects.",
    prompt:
      "Animate the video to simulate fire: glowing embers, flickering flames, realistic light reflections, warm cinematic glow, dramatic movement.",
    fluxCost: 10,
    type: "video",
    creatorId: "dreamworld",
    useCount: 0,
    createdAt: Timestamp.now(),
  },
  {
    id: "10",
    title: "Ghostly Apparition",
    image:
      "https://plus.unsplash.com/premium_photo-1681488235165-85397d7045aa?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NXx8R2hvc3R8ZW58MHx8MHx8fDA%3D",
    description: "Gives subjects a translucent, ghostly appearance.",
    recommendedImageDesc:
      "Best with a single person or object in a simple environment.",
    prompt:
      "Render the video to look ghostly: semi-transparent figures, ethereal glow, soft floating motion, mysterious and cinematic atmosphere.",
    fluxCost: 10,
    type: "video",
    creatorId: "dreamworld",
    useCount: 0,
    createdAt: Timestamp.now(),
  },
  {
    id: "11",
    title: "Golden Hour Glow",
    image:
      "https://images.stockcake.com/public/d/a/2/da24bd4a-8d0f-4adc-9f6a-3d4d19b70489_large/golden-hour-glow-stockcake.jpg",
    description:
      "Bathes your video in a warm, golden light, mimicking the golden hour.",
    recommendedImageDesc: "Enhances outdoor scenes, portraits, and landscapes.",
    prompt:
      "Animate the video to reflect golden hour lighting: warm sunlight, soft shadows, gentle lens flares, cinematic glow, peaceful and beautiful ambiance.",
    fluxCost: 10,
    type: "video",
    creatorId: "dreamworld",
    useCount: 0,
    createdAt: Timestamp.now(),
  },
  {
    id: "12",
    title: "Stop Motion Clay",
    image:
      "https://i0.wp.com/www.ikitmovie.com/wp-content/uploads/2018/07/wallace2s.jpg?fit=300%2C238&ssl=1",
    description: "Reimagines your video as a claymation stop motion animation.",
    recommendedImageDesc:
      "Works with any subject, gives a playful and handmade feel.",
    prompt:
      "Create the video in stop-motion clay style: slightly jerky motion, textured clay look, handcrafted animation, playful and charming movement.",
    fluxCost: 10,
    type: "video",
    creatorId: "dreamworld",
    useCount: 0,
    createdAt: Timestamp.now(),
  },
  {
    id: "13",
    title: "Holographic Projection",
    image:
      "https://media.istockphoto.com/id/482461333/fr/photo/projeter-lavenir.webp?a=1&b=1&s=612x612&w=0&k=20&c=o4Z1Byp4RoxWINpuW9Z49B8W9DgCSiHxP3hLfIao14E=",
    description: "Turns your subject into a futuristic holographic projection.",
    recommendedImageDesc:
      "Ideal for portraits or tech-related objects on dark backgrounds.",
    prompt:
      "Render the video as a holographic projection: semi-transparent 3D forms, glowing lines, digital sci-fi effects, futuristic and immersive motion.",
    fluxCost: 10,
    type: "video",
    creatorId: "dreamworld",
    useCount: 0,
    createdAt: Timestamp.now(),
  },
  {
    id: "14",
    title: "Comic Book Pop",
    image:
      "https://images.unsplash.com/photo-1618519764140-d3cdc6496de1?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTF8fENvbWljJTIwQm9vayUyMFBvcHxlbnwwfHwwfHx8MA%3D%3D",
    description:
      "Applies a comic book art style with halftones and bold outlines.",
    recommendedImageDesc: "Great for action shots and expressive portraits.",
    prompt:
      "Animate the video in comic book style: bold outlines, halftone shading, pop-art colors, dynamic frames, exaggerated motion, cinematic comic feel.",
    fluxCost: 10,
    type: "video",
    creatorId: "dreamworld",
    useCount: 0,
    createdAt: Timestamp.now(),
  },
  {
    id: "15",
    title: "Light Leaks",
    image:
      "https://images.unsplash.com/photo-1550275994-cdc89cd1948f?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTB8fExpZ2h0JTIwTGVha3N8ZW58MHx8MHx8fDA%3D",
    description: "Overlays your video with beautiful, vintage light leaks.",
    recommendedImageDesc: "Adds a nostalgic and dreamy feel to any footage.",
    prompt:
      "Add animated light leaks across the video: soft flares, warm vintage tones, shifting highlights, dreamy cinematic motion, gentle light transitions.",
    fluxCost: 10,
    type: "video",
    creatorId: "dreamworld",
    useCount: 0,
    createdAt: Timestamp.now(),
  },
  {
    id: "16",
    title: "Blueprint Draft",
    image:
      "https://images.unsplash.com/photo-1743385779347-1549dabf1320?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8Qmx1ZXByaW50JTIwRHJhZnR8ZW58MHx8MHx8fDA%3D",
    description:
      "Converts your video into a technical blueprint-style animation.",
    recommendedImageDesc:
      "Best for architecture, vehicles, and mechanical objects.",
    prompt:
      "Animate the video in blueprint style: white lines on blue background, technical schematic motion, smooth transitions, precision and schematic clarity.",
    fluxCost: 10,
    type: "video",
    creatorId: "dreamworld",
    useCount: 0,
    createdAt: Timestamp.now(),
  },
  {
    id: "17",
    title: "Psychedelic Swirl",
    image:
      "https://images.unsplash.com/photo-1749262503877-d5d4f0f8a192?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8UHN5Y2hlZGVsaWMlMjBTd2lybHxlbnwwfHwwfHx8MA%3D%3D",
    description:
      "Creates a swirling, psychedelic visual experience with vibrant colors.",
    recommendedImageDesc: "Works on any footage for a trippy, abstract effect.",
    prompt:
      "Animate the video with psychedelic swirling patterns: vibrant flowing colors, abstract liquid motion, continuous dynamic loops, trippy visual experience.",
    fluxCost: 10,
    type: "video",
    creatorId: "dreamworld",
    useCount: 0,
    createdAt: Timestamp.now(),
  },
  {
    id: "18",
    title: "Frozen Ice",
    image:
      "https://media.istockphoto.com/id/2160467272/fr/photo/beautiful-frost-pattern-on-a-window-glass.webp?a=1&b=1&s=612x612&w=0&k=20&c=NsBSdmv3Gjc7IMl5X6ixi-oQkdieInY-s6drGPfe5AM=",
    description: "Covers your video in a layer of frost and ice.",
    recommendedImageDesc:
      "Ideal for winter scenes or to add a cold effect to any subject.",
    prompt:
      "Render the video to appear frozen: ice crystals forming, frosty edges, cold color palette, subtle shimmering on surfaces, wintery atmosphere.",
    fluxCost: 10,
    type: "video",
    creatorId: "dreamworld",
    useCount: 0,
    createdAt: Timestamp.now(),
  },
  {
    id: "19",
    title: "Matrix Code",
    image:
      "https://media.istockphoto.com/id/2198475335/fr/photo/donn%C3%A9es-en-continu-donn%C3%A9es-binaires-se-d%C3%A9pla%C3%A7ant-sur-une-route-num%C3%A9rique-concept-routier-du.webp?a=1&b=1&s=612x612&w=0&k=20&c=h2za-W5t9IgvqQ_Pj2dU9L3Cir_AjHfSOyGckHpE3Tc=",
    description: "Transforms your video into cascading green digital code.",
    recommendedImageDesc:
      "Best with a single subject against a simple background.",
    prompt:
      "Animate the video with Matrix-style digital rain: cascading green code, flowing binary lines, futuristic hacker aesthetic, immersive digital motion.",
    fluxCost: 10,
    type: "video",
    creatorId: "dreamworld",
    useCount: 0,
    createdAt: Timestamp.now(),
  },
  {
    id: "20",
    title: "Rainy Window",
    image:
      "https://plus.unsplash.com/premium_photo-1671229652411-4468b946b787?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NXx8UmFpbnklMjBXaW5kb3d8ZW58MHx8MHx8fDA%3D",
    description:
      "Simulates viewing your scene through a window on a rainy day.",
    recommendedImageDesc: "Adds a cozy and melancholic mood to any scene.",
    prompt:
      "Render the video as seen through a rainy window: animated water droplets sliding down glass, blurred background, soft melancholic lighting, cozy cinematic feel.",
    fluxCost: 10,
    type: "video",
    creatorId: "dreamworld",
    useCount: 0,
    createdAt: Timestamp.now(),
  },
];
